/**
 * Route index — root redirect.
 * Authenticated users go to /app; others get the root placeholder.
 * Full auth gate lands in Phase 3 (Track 3.B).
 */

import { Navigate } from "react-router";

export default function RootIndex() {
  // Phase 3 will check auth state here and redirect to /app or onboarding.
  // For now redirect to /app so the placeholder workspace is visible.
  return <Navigate to="/app" replace />;
}
